<template>
  <div>
    <!-- <el-row style="padding-left:20px">
      <el-col>
        <el-form :inline="true" class="demo-form-inline" style="margin: 0;" :model="searchForm" ref="searchForm">
          <el-form-item label="团餐公司：">
            <el-select size="medium" filterable v-model="searchForm.SUB_TC_ID" placeholder="请选择团餐公司" clearable>
              <el-option v-for="item in newTcList" :key="item.TC_ID" :label="item.TC_NAME" :value="item.TC_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类名称：">
            <el-input size="medium" v-model="searchForm.CATALOG_NAME"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="padding-left:20px;margin-bottom: 10px">
      <el-button size="medium" @click="queryList()">筛选</el-button>
      <el-button style="color: rgb(96,98,102)" @click="clearSearch" type="text">重置筛选条件</el-button>
    </el-row>
    <div class="middle">
      <el-button size="medium" @click="addKind()">新增</el-button>
    </div> -->
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column prop="CATALOG_NAME" label="分类名称" min-width="120"></el-table-column>
          <el-table-column prop="TAX_RATE" label="税率"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="changeThis(scope.row)">修改</el-button>
              <el-button type="text" @click="productManage(scope.row)">产品管理</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="margin: 10px 0">
          <el-pagination v-show="total_count > pageSize" style="float:right;" @current-change="handleCurrentChange"
            :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper"
            :total="total_count">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
    <!--新增的模态框-->
    <el-dialog title="新增" :visible.sync="addVisible" width="600px" center>
      <el-form :ref="addForm" :model="addForm" :rules="rule" @keyup.enter.native="addSure">
        <el-form-item label="分类名称：">
          <el-select filterable v-model="addForm.CATALOG_CODE" clearable placeholder="请选择" style="width:450px;">
            <el-option v-for="item in listKinds" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="税率:" label-width="80px" prop="TAX_RATE">
          <el-input v-model="addForm.TAX_RATE" style="width:450px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取消</el-button>
        <el-button @click="addSure()">确定</el-button>
      </span>
    </el-dialog>
    <!--修改的模态框-->
    <el-dialog title="修改" :visible.sync="changeVisible" width="600px" center>
      <el-form :ref="modifyForm" :model="modifyForm" :rules="rule" @keyup.enter.native="modifySure">
        <el-form-item label="税率:" label-width="100px" prop="TAX_RATE">
          <el-input v-model="modifyForm.TAX_RATE" style="width:450px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="生效日期：" label-width="100px">
          <el-date-picker v-model="modifyForm.EFFECT_DAY" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            style="width:450px;">
          </el-date-picker>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeVisible = false">取消</el-button>
        <el-button @click="modifySure()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getClassFun } from 'api/skuManage';
import http from '@/assets/common/http';

export default {
  props: {
    searchForm: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      formLabelWidth: '80px',
      rule: {
        TAX_RATE: [{ required: true, message: '请输入税率', trigger: 'blur' }],
      },
      changeVisible: false,
      tableData: [],
      // searchForm: {
      //   CATALOG_NAME: '',
      // },
      currentPage: 1,
      pageSize: 15,
      modifyForm: {},
      total_count: 0,
      addVisible: false,
      addForm: {},
      listKinds: [],
      newTcList: [],
      reg: /^[0-9]+(.[0-9]{1})?$/,
    };
  },
  computed: {
    // KINDTAX_DATA_CONDITION() {
    //   return this.$store.state.KINDTAX_DATA_CONDITION;
    // },
  },
  created() {
    // if ('CONDITION' in this.KINDTAX_DATA_CONDITION && 'DATA' in this.KINDTAX_DATA_CONDITION && 'TOTAL_COUNT' in this.KINDTAX_DATA_CONDITION) {
    //   this.tableData = this.KINDTAX_DATA_CONDITION.DATA;
    //   this.searchForm = this.KINDTAX_DATA_CONDITION.CONDITION;
    //   this.total_count = this.KINDTAX_DATA_CONDITION.TOTAL_COUNT;
    // }
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.firstList();
  },
  methods: {
    productManage(row) {
      this.$router.push({ path: `/productManage_kind/${row.TABLE_ID}/${row.SUPPLIER_CATALOG_ID}`, params: { tid: row.TABLE_ID, cid: row.SUPPLIER_CATALOG_ID } });
    },
    queryList() {
      this.currentPage = 1;
      this.firstList();
    },
    // 查询所有未添加的分类
    queryKinds() {
      getClassFun().then((result) => {
        this.listKinds = result;
        this.addVisible = true;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增
    addKind() {
      this.queryKinds();
    },
    addSure() {
      if (!this.addForm.CATALOG_CODE) {
        this.$message.show({ text: '请选择分类', type: 'warning' });
        return false;
      }
      if (!this.reg.test(this.addForm.TAX_RATE || this.addForm.TAX_RATE >= 100)) {
        this.$message.show({ text: '请输入小于100且至多一位小数的正数税率', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '15066',
        OTYPE: 9,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        CATALOG_ID: this.addForm.CATALOG_CODE,
        TAX_RATE: this.addForm.TAX_RATE,
      };
      http.post(params).then((result) => {
        this.addForm = {};
        this.$message.show({ text: '新增成功', type: 'success' });
        this.currentPage = 1;
        this.firstList();
        this.addVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 拉取列表
    firstList() {
      const params = {
        SERVICE_ID: '15066',
        OTYPE: 7,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.CATALOG_NAME) {
        params.CATALOG_NAME = this.searchForm.CATALOG_NAME;
      }
      http.post(params).then((result) => {
        if (result[0].TOTAL_COUNT == 0) {
          this.total_count = 0;
          this.tableData = [];
        } else {
          this.total_count = result[0].TOTAL_COUNT;
          this.tableData = result[0].LIST;
        }
        if (this.searchForm) {
          // this.$store.dispatch('SET_KINDTAX_DATA_CONDITION', {
          //   CONDITION: this.searchForm,
          //   DATA: this.tableData,
          //   TOTAL_COUNT: this.total_count,
          // });
        }
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.firstList();
    },
    // 修改
    changeThis(row) {
      this.modifyForm = { ...row };
      this.changeVisible = true;
    },
    // 修改确认
    modifySure() {
      // if (!this.modifyForm.EFFECT_DAY) {
      //   this.$message.show({ text: '请选择生效日期', type: 'warning' });
      //   return false;
      // }
      if (!this.reg.test(this.modifyForm.TAX_RATE) || this.modifyForm.TAX_RATE >= 100) {
        this.$message.show({ text: '请输入小于100且至多一位小数的正数税率', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '15066',
        OTYPE: 8,
        TABLE_ID: this.modifyForm.TABLE_ID,
        TAX_RATE: this.modifyForm.TAX_RATE,
        // EFFECT_DAY: this.modifyForm.EFFECT_DAY,
      };
      http.post(params).then((result) => {
        // this.currentPage = 1;
        this.modifyForm = {};
        this.firstList();
        this.$message.show({ text: '修改成功', type: 'success' });
        this.changeVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    clearSearch() {
      // this.searchForm = {};
    },
  },
};
</script>

<style scoped>
.middle {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f5f7f9;
  padding: 0 40px;
  margin: 0 -20px 0 -20px;
}
</style>



// WEBPACK FOOTER //
// src/components/SKUManage/kindTax.vue